import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { authLinks } from "./middleware/auth";

const client = new ApolloClient({
  link: ApolloLink.from(authLinks),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export default client;
